const routes = [
    {
        path: "/sections",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "section_index"
        },
        component_full_path: 'sections/pages/Index'
    },
    {
        path: "/sections/close",
        component: () => import("../pages/Close"),
        meta: {
            isAuthenticated: true,
            permission: "section_close"
        }
    },
    {
        path: "/instructor/courses",
        component: () => import("../pages/instructor/Courses"),
        meta: {
            isAuthenticated: true,
            permission: "section_instructor"
        },
        component_full_path: 'sections/pages/instructor/Courses'
    }
];

export default routes;
